import React, { useState, useRef } from "react";
import axios from "axios";
import { motion } from "framer-motion";

const API_URL = 'https://backend.aktcorp.com/compliances/addcomplinaces';

const AddEvent = () => {
  const [formData, setFormData] = useState({ image: null, pdf: null });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});
  const imageInputRef = useRef(null);
  const pdfInputRef = useRef(null);

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        // Extract base64 string only (after comma)
        setFormData((prev) => ({ ...prev, [type]: reader.result.split(",")[1] }));
      };
    }
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.image) newErrors.image = "* Image is required";
    if (!formData.pdf) newErrors.pdf = "* PDF is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setErrors({});
    setSuccessMessage("");

    const token = localStorage.getItem("authToken"); // Replace with your JWT token key in storage

    if (!token) {
      setErrors({ api: "Authentication token missing. Please login." });
      setLoading(false);
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      imageBase64: formData.image,
      pdfBase64: formData.pdf,
    };

    try {
      const response = await axios.post(API_URL, payload, { headers });
      setLoading(false);
      setSuccessMessage(response.data.message || "Uploaded successfully!");
      setFormData({ image: null, pdf: null });
      if (imageInputRef.current) imageInputRef.current.value = "";
      if (pdfInputRef.current) pdfInputRef.current.value = "";

      setTimeout(() => setSuccessMessage(""), 5000);
    } catch (error) {
      setLoading(false);
      console.error("Upload failed:", error);
      setErrors({ api: "Upload failed. Please try again." });
    }
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white shadow-md rounded-lg">
      <motion.h2
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-3xl font-bold text-gray-900 text-center mb-4 bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text"
      >
        Add Image & PDF
      </motion.h2>

      <form onSubmit={handleSubmit}>
        <p className="font-semibold">Upload Image:</p>
        <input
          ref={imageInputRef}
          type="file"
          accept="image/*"
          className="mb-2"
          onChange={(e) => handleFileChange(e, "image")}
        />
        {errors.image && <p className="text-red-500 text-sm mb-2">{errors.image}</p>}

        {formData.image && (
          <img
            src={`data:image/jpeg;base64,${formData.image}`}
            alt="Preview"
            className="w-full h-40 object-cover rounded-md my-2"
          />
        )}

        <p className="font-semibold">Upload PDF:</p>
        <input
          ref={pdfInputRef}
          type="file"
          accept="application/pdf"
          className="mb-2"
          onChange={(e) => handleFileChange(e, "pdf")}
        />
        {errors.pdf && <p className="text-red-500 text-sm mb-2">{errors.pdf}</p>}

        {errors.api && <p className="text-red-500 text-center mb-2">{errors.api}</p>}

        {!loading ? (
          <button
            type="submit"
            className="w-full bg-blue-500 text-white p-2 mt-2 rounded-md"
          >
            Upload
          </button>
        ) : (
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
            className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"
          />
        )}
      </form>

      {successMessage && (
        <div className="mt-4 text-green-500 text-center">{successMessage}</div>
      )}
    </div>
  );
};

export default AddEvent;
